import { STRAPI_URL } from "../env";

function getFilenameFromContentDisposition(header: string | null): string {
  if (!header) return "";
  // RFC 5987 encoded filename*=UTF-8''...
  const encodedMatch = /filename\*=(?:UTF-8'')?([^;]+)/i.exec(header);
  if (encodedMatch?.[1]) {
    try {
      return decodeURIComponent(encodedMatch[1].trim().replace(/^"|"$/g, ""));
    } catch {
      // fall through
    }
  }
  // Plain filename="..."
  const plainMatch = /filename="?([^";]+)"?/i.exec(header);
  return plainMatch?.[1]?.trim() ?? "";
}

/**
 * Downloads the "all data fields" export of Business Application records the
 * user is currently permitted to see (and, respecting their active filters
 * client-side), as computed by the caller. The backend returns the actual
 * filename via `Content-Disposition`, so it is never hardcoded here.
 */
export async function downloadBusinessAppExport(
  itemIds: string[],
  activeFilterLabels?: string[]
): Promise<boolean> {
  try {
    const pageQuery = new URLSearchParams(window.location.search);
    const exportQuery = new URLSearchParams();
    // Preserve values and repetitions so the backend validates the opt-in.
    for (const value of pageQuery.getAll("includeDisabled")) {
      exportQuery.append("includeDisabled", value);
    }
    const query = exportQuery.toString();
    const exportUrl = `${STRAPI_URL}/business-app-export${query ? `?${query}` : ""}`;
    const response = await fetch(exportUrl, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ itemIds, activeFilterLabels }),
    });

    if (!response.ok) {
      console.error(`Business app export failed: ${response.status}`);
      return false;
    }

    const blob = await response.blob();
    const filename = getFilenameFromContentDisposition(
      response.headers.get("Content-Disposition")
    );

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);

    return true;
  } catch (error) {
    console.error("Business app export failed:", error);
    return false;
  }
}
